import {
  AspectRatio,
  Box,
  Button,
  Flex,
  HStack,
  Image,
  Spinner,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";
import VideoPlayer from "../components/data-display/VideoPlayer";
import { EditContainer } from "./Shared";

type Props = {
  isOpen: boolean;
  loading: { accept: boolean; reject: boolean };
  mediaType: "image" | "video";
  mediaUrl: string;
  onAccept: () => Promise<void>;
  onClose?: () => void;
  onReject: () => Promise<void>;
  profileUrl?: string;
  userInfo?: { name: string; dob: string; gender: "Male" | "Female" };
  useModal?: boolean;
};
console.log('VideoPlayer',VideoPlayer)
export default function ReviewMediaUpload({
  isOpen,
  loading,
  mediaType,
  mediaUrl,
  onAccept,
  onClose,
  onReject,
  profileUrl,
  userInfo,
  useModal = true,
}: Props) {
  const isImageUpload = mediaType === "image";
  return (
    <EditContainer
      header={`Review ${isImageUpload ? "image" : "video"}`}
      isOpen={isOpen}
      onClose={onClose}
      useModal={useModal}
    >
      <Stack spacing={3}>
        {isImageUpload ? (
          <Stack spacing={2}>
            <Box>
              <Image
                alt="profile photo"
                fallback={
                  <Flex align="center" justify="center" py="40px">
                    <Spinner
                      thickness="4px"
                      speed="0.65s"
                      emptyColor="gray.200"
                      color="blue.500"
                      size="xl"
                    />
                  </Flex>
                }
                maxW="100%"
                src={profileUrl}
              />
            </Box>
            <Box>
              <Image
                alt="id photo"
                fallback={
                  <Flex align="center" justify="center" py="40px">
                    <Spinner
                      thickness="4px"
                      speed="0.65s"
                      emptyColor="gray.200"
                      color="blue.500"
                      size="xl"
                    />
                  </Flex>
                }
                maxW="100%"
                src={mediaUrl}
              />
            </Box>
          </Stack>
        ) : (
          <AspectRatio ratio={16 / 9}>
            <VideoPlayer controls url={mediaUrl} />
          </AspectRatio>
        )}
        {userInfo && (
          <Stack spacing={2}>
            <Text>
              <b>Name: </b>
              {userInfo.name}
            </Text>
            <Text>
              <b>DOB: </b>
              {userInfo.dob}
            </Text>
            <Text>
              <b>Gender: </b>
              {userInfo.gender}
            </Text>
            <Text>
              <b>Profile: </b>
              <a target="_blank" href={profileUrl}>
                Profile Pic
              </a>
            </Text>

            <Text>
              <b>ID: </b>
              <a target="_blank" href={mediaUrl}>
                ID Url
              </a>
            </Text>
          </Stack>
        )}
      </Stack>
      <HStack mt={4} justifyContent="space-between" width="100%">
        <Button
          colorScheme="red"
          isLoading={loading.reject}
          width="200px"
          loadingText="Processing..."
          onClick={onReject}
        >
          Reject
        </Button>
        <Button
          colorScheme="blue"
          width="200px"
          isLoading={loading.accept}
          loadingText="Processing..."
          onClick={onAccept}
        >
          Accept
        </Button>
      </HStack>
    </EditContainer>
  );
}
